import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteAdminConversationForm } from '@entities/AdminConversationCategory/api/handlers/deleteAdminConversationForm';

export function useDeleteAdminConversationFormQuery() {
    const qc = useQueryClient();

    return useMutation({
        mutationFn: deleteAdminConversationForm,
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ['adminConversationCategories'] });
        },
    });
}
